import React from 'react';
import House2 from './Assets/Images/House7.webp';

const ExploreWork = () => {
  return (
    <div className="bg-black py-24 w-full">
      <h1 className="text-white text-3xl md:text-4xl text-center">Explore Our Work</h1>
      <p className="text-white text-center mt-6 mx-auto w-full">
        Discover our <b>signature style, functional layouts, and detailed finishing</b> that make us stand out.
      </p>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 px-6 md:px-20 pt-16">
        {/* Keep your <img> tag style — replace src later */}
        <img src={House2} data-aos="zoom-in"/>
        <img src={House2} data-aos="zoom-in"/>
        <img src={House2} data-aos="zoom-in"/>
        <img src={House2} data-aos="zoom-in"/>
        <img src={House2} data-aos="zoom-in"/>
        <img src={House2} data-aos="zoom-in"/>
        <img src={House2} data-aos="zoom-in"/>
        <img src={House2} data-aos="zoom-in"/>
        <img src={House2} data-aos="zoom-in"/>
      </div>
    </div>
  );
};

export default ExploreWork;
